// One vocabulary for a payment frequency (wizard parity C14 / C15, Sahil,
// 2026-10-18): property_insurance.premium_frequency and
// hoa_payments.frequency hold exactly `monthly`, `quarterly` or `annual`,
// lowercase, and the database CHECKs it (migration 20261018030000). The
// Insurance page used to write "Annual" / "Quarterly" while the wizard and
// the import wrote lowercase, so an annual total that compared against
// "Monthly" counted a lowercase monthly premium once instead of twelve times,
// and a report printed whichever spelling the row happened to have.
//
// Pure, no imports: tests load this file as-is.

export const FREQS = ["monthly", "quarterly", "annual"];
export const FREQ_LABELS = { monthly: "Monthly", quarterly: "Quarterly", annual: "Annual" };

// What the import's enum map and the pages have ever written, folded onto
// the three values. Anything unrecognised is `fallback` (null when none is
// given), never passed through.
const ALIASES = {
  monthly: "monthly", month: "monthly", mo: "monthly", m: "monthly",
  quarterly: "quarterly", quarter: "quarterly", q: "quarterly",
  annual: "annual", annually: "annual", yearly: "annual", year: "annual", yr: "annual", a: "annual", y: "annual",
};
export function normalizeFrequency(v, fallback = null) {
  const k = String(v ?? "").trim().toLowerCase();
  return k && ALIASES[k] ? ALIASES[k] : fallback;
}

// How a frequency reads on a page or in a document.
export function frequencyLabel(v) {
  const f = normalizeFrequency(v);
  if (f) return FREQ_LABELS[f];
  const s = String(v ?? "").trim();
  return s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : "";
}

// "$120/mo", "$360/qtr", "$1,440/yr".
export function frequencyUnit(v) {
  const f = normalizeFrequency(v);
  return f === "monthly" ? "mo" : f === "quarterly" ? "qtr" : "yr";
}

// How many times a year it is paid; an unknown frequency counts once.
export function paymentsPerYear(v) {
  const f = normalizeFrequency(v);
  return f === "monthly" ? 12 : f === "quarterly" ? 4 : 1;
}

// The yearly figure for an amount paid at this frequency.
export function annualise(amount, v) {
  const n = Number(amount);
  if (!Number.isFinite(n)) return 0;
  return n * paymentsPerYear(v);
}
